/* RESPONSIBLE TEAM: team-frontend-tech */
import THelper from 'ember-intl/helpers/t';

export default class CustomTHelper extends THelper {
  compute([value, context], options) {
    return super.compute([value], { ...context, ...options });
  }
}
